import { Component } from '@angular/core';

@Component({
    selector: 'ng1-placeholder',
    template: `
      <!-- This is empty in Angular router outlet while angularJS router will display angularJS content in ng-view -->
      `
})
export class Ng1PlaceholderComponent  {}
